namespace RedBullMOBILE360.CVM {
    export class CvmCampaignColumns {
        static columnsKey = 'CVM.CvmCampaign';
    }
}